export default function BrandMark({ compact = false }: { compact?: boolean }) {
  return (
    <div className="brand-mark">
      <span className="brand-glyph">L</span>
      {!compact && <span className="brand-word">LAMSA TABLE</span>}
    </div>
  )
}
